<h2 mat-dialog-title class="dlg-title">{{ title }}</h2>
<mat-dialog-content class="dlg-body">
  @if (store.view; as v) {
    <section class="dlg-row scope-row">
      <div class="lbl">Pour</div>
      <div class="scope">
        @for (g of groups; track g.key) {
          <div class="grp">
            <label class="grp-head">
              <input type="checkbox" [checked]="groupState(g) === 'all'" [indeterminate]="groupState(g) === 'some'" [disabled]="!groupOpen(g)"
                (change)="toggleGroup(g, $any($event.target).checked)" [attr.aria-label]="'Cocher ' + g.label" />
              <span><b>{{ g.label }}</b> ({{ g.lines.length }})</span>
            </label>
            <div class="scope-list">
              @for (l of g.lines; track l.id) {
                <label [class.off]="!!l.why" [attr.title]="l.why">
                  <input type="checkbox" [checked]="checked.has(l.id)" [disabled]="!!l.why" (change)="toggle(l.id, $any($event.target).checked)" />
                  <span class="nm">{{ l.name }}<small>{{ l.note }}</small>@if (l.why) {<small class="why">{{ l.why }}</small>}</span>
                </label>
              }
            </div>
          </div>
        }
      </div>
      <div class="hint">
        Une décision est enregistrée par matériel coché.
        @if (groups.length >= 2) {<button type="button" class="link" (click)="checkAll()">Tout cocher</button>}
      </div>
    </section>

    @if (heads.length) {
      <section class="dlg-row">
        <div class="lbl">{{ bound === 'START' ? 'Début de facturation' : 'Fin de facturation' }} par matériel</div>
        @for (h of heads; track h.id) {
          <div class="head">
            <div class="head-top">
              <span class="head-txt"><b>{{ h.name }}</b>@if (h.memo) {<span> · {{ h.memo }}</span>}<span class="facts"> · {{ h.facts }}</span></span>
              @if (h.effectiveId !== null) {
                <button mat-stroked-button color="warn" type="button" class="cancel-bound" (click)="cancelBound(h.id)">Annuler cette borne</button>
              }
            </div>
            <div class="cur">{{ h.current }}</div>
            @if (h.history.length) {
              <ul class="hist">
                @for (e of h.history; track e.id) {
                  <li [class.cancelled]="!!e.cancelled" [class.current]="e.effective">
                    <div class="main">
                      <span class="what">{{ e.what }}</span>@if (e.effective) {<span class="eff"> · retenue</span>}
                      <small>{{ e.stamp }}</small>
                      @if (e.cancelled) {<small>{{ e.cancelled }}</small>}
                    </div>
                  </li>
                }
              </ul>
            }
          </div>
        }
      </section>
    }

    <section class="dlg-row">
      <div class="lbl">Motif</div>
      @if (reasons.length) {
        <div class="chips">
          @for (r of reasons; track r.id) {
            <button type="button" class="chip" [attr.aria-pressed]="reasonId === r.id" (click)="pickReason(r.id)">
              <span class="rdot" [style.background]="r.color ?? (bound === 'START' ? 'var(--violet)' : 'var(--ink-3)')"></span>{{ r.name }}
            </button>
          }
        </div>
      } @else if (store.reasonsState === 'loading') {
        <div class="loading"><mat-spinner diameter="16"></mat-spinner>Motifs en cours de chargement</div>
      } @else if (store.reasonsState === 'error') {
        <div class="hint reasons-error">Motifs illisibles (c_values 42). <button mat-stroked-button type="button" class="retry-reasons" (click)="store.ensureReasons()">Réessayer</button></div>
      } @else {
        <div class="hint">Aucun motif {{ bound === 'START' ? 'WINDOW_START' : 'WINDOW_END' }} actif dans c_values 42.</div>
      }
      <input class="comment" type="text" [value]="comment" (input)="setComment($any($event.target).value)"
        [placeholder]="commentRequired ? 'Commentaire (obligatoire)' : 'Commentaire (facultatif)'" aria-label="Commentaire" />
      @if (needsReplaceReason) {
        <input class="comment replace" type="text" [value]="replaceReason" (input)="setReplaceReason($any($event.target).value)"
          placeholder="Motif du remplacement (obligatoire) : la borne actuelle sera annulée" aria-label="Motif du remplacement" />
      }
    </section>

    <section class="dlg-row">
      <div class="field active">
        <label for="window-day">{{ fieldLabel }}</label>
        <input id="window-day" type="text" [value]="dayValue" (change)="typed($event)" placeholder="JJ/MM/AAAA" autocomplete="off" />
      </div>
      @if (leftMonth; as lm) {
        <app-rental-day-picker mode="single" [start]="day" [end]="null" [leftMonth]="lm" [today]="v.as_of" [marks]="marks"
          [tone]="bound === 'START' ? 'violet' : 'slate'" (startChange)="pickDay($event)" (leftMonthChange)="setLeftMonth($event)" (escape)="close()"></app-rental-day-picker>
      }
    </section>
  } @else if (store.error) {
    <div class="blocked">{{ store.error }}</div>
  } @else {
    <div class="loading"><mat-spinner diameter="24"></mat-spinner>Chargement du dossier</div>
  }
</mat-dialog-content>
<div class="dlg-effect">
  <app-rental-effect [state]="sim" [rangeText]="rangeText" [warnings]="warnings" [errors]="errors" [scope]="scope" [focusLineIds]="focusIds" [store]="store"></app-rental-effect>
</div>
<mat-dialog-actions class="dlg-actions">
  <span class="spacer"></span>
  <button mat-stroked-button type="button" class="close" (click)="close()" [disabled]="saving">Fermer</button>
  <button mat-flat-button color="primary" type="button" class="save" [disabled]="!canSave || saving" (click)="save()">Enregistrer</button>
</mat-dialog-actions>
